import { render } from "./UiPropMargins.vue?vue&type=template&id=5e31a09b&scoped=true"
import script from "./UiPropMargins.vue?vue&type=script&lang=js"
export * from "./UiPropMargins.vue?vue&type=script&lang=js"

import "./UiPropMargins.vue?vue&type=style&index=0&id=5e31a09b&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e31a09b"]])

export default __exports__